import { render, staticRenderFns } from "./voiceComposeCustom.vue?vue&type=template&id=7a391f7a&scoped=true&"
import script from "./voiceComposeCustom.vue?vue&type=script&lang=js&"
export * from "./voiceComposeCustom.vue?vue&type=script&lang=js&"
import style0 from "./voiceComposeCustom.vue?vue&type=style&index=0&id=7a391f7a&lang=less&scoped=true&"
import style1 from "./voiceComposeCustom.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a391f7a",
  null
  
)

component.options.__file = "voiceComposeCustom.vue"
export default component.exports